import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScollToTop";

import { useUserVoteDashboard } from "./hooks/useUserVoteDashboard";

import UserVoteDashboardHeader from "./components/UserVoteDashboardHeader";
import UserVoteFilters from "./components/UserVoteFilters";
import UserVoteKpiCards from "./components/UserVoteKpiCards";
import UserVoteCard from "./components/UserVoteCard";
import UserVoteLoadingState from "./components/UserVoteLoadingState";
import UserVoteEmptyState from "./components/UserVoteEmptyState";
import ParticipateVoteDrawer from "./components/ParticipateVoteDrawer";
import UserBallotAnswersDrawer from "./components/UserBallotAnswersDrawer";

export default function UserVoteDashboard() {
  useScrollToTop();

  const {
    userId,

    votes,
    filteredVotes,
    ballots,
    loading,

    filters,
    setFilters,
    stats,

    selectedVoteId,
    participateOpen,
    answersOpen,

    refresh,
    openParticipate,
    closeParticipate,
    openAnswers,
    closeAnswers,
    getBallot,
  } = useUserVoteDashboard();

  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5 px-3 sm:px-4 lg:px-6">
        <UserVoteDashboardHeader
          loading={loading}
          onRefresh={refresh}
          userId={userId}
        />

        <UserVoteKpiCards stats={stats} loading={loading} />

        <UserVoteFilters
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={votes.length}
          count={filteredVotes.length}
          onRefresh={refresh}
        />

        <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

          <div className="p-4 sm:p-5 lg:p-6">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  Votes & sondages
                </p>

                <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                  Consultations proposées
                </h2>

                <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                  Retrouvez les votes et sondages du club, participez aux
                  consultations ouvertes et consultez vos réponses déjà
                  enregistrées.
                </p>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm dark:border-slate-700 dark:bg-slate-800/60">
                <span className="text-slate-500 dark:text-slate-400">
                  Résultats :
                </span>{" "}
                <span className="font-bold text-slate-900 dark:text-white">
                  {filteredVotes.length}
                </span>
                <span className="text-slate-500 dark:text-slate-400">
                  {" "}
                  / {votes.length}
                </span>
              </div>
            </div>

            <div className="mt-5">
              {loading ? (
                <UserVoteLoadingState />
              ) : filteredVotes.length === 0 ? (
                <UserVoteEmptyState
                  hasSearch={Boolean(filters.search?.trim())}
                  onReset={() =>
                    setFilters({
                      search: "",
                      type: "all",
                      status: "available",
                    })
                  }
                />
              ) : (
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                  {filteredVotes.map((vote) => {
                    const ballot = getBallot(vote.id);

                    return (
                      <UserVoteCard
                        key={vote.id}
                        vote={vote}
                        ballot={ballot}
                        onParticipate={() => openParticipate(vote.id)}
                        onViewAnswers={() => openAnswers(vote.id)}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </section>
      </div>

      <ParticipateVoteDrawer
        isOpen={participateOpen}
        voteId={selectedVoteId}
        userId={userId}
        onClose={closeParticipate}
        onSubmitted={refresh}
      />

      <UserBallotAnswersDrawer
        isOpen={answersOpen}
        voteId={selectedVoteId}
        userId={userId}
        onClose={closeAnswers}
      />

      <ToastContainer />
    </section>
  );
}